<template>
  <v-dialog
    persistent
    v-model='get_dialogMain.dialog'
    :width='get_dialogMain.withWindows'
    justify-center>
    <v-toolbar dense dark color='blue darken-2'>
      <v-toolbar-title>
        <h3>{{ get_dialogMain.title }}</h3>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click='HIDDE_DIALOG_MAIN()'>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <PermisoForm :model='permiso' :on-success='savePermiso' :on-cancel='cancel' />
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import PermisoForm from '@/components/forms/PermisoForm'
export default {
  data: () => ({
    permiso: {
      descripcion: ''
    }
  }),
  components: {
    PermisoForm
  },
  methods: {
    ...mapActions(['postServiceAction']),
    savePermiso (model) {
      let router = null
      if (this.get_dialogMain.type === 'create') {
        router = this.get_urls['POST/config/auth/permisos/store']
      } else {
        router = this.get_urls['POST/config/auth/permisos/update']
      }
      this.postServiceAction({ url: router, data: model })
    },
    cancel () {
      this.HIDDE_DIALOG_MAIN()
    },
    ...mapMutations(['HIDDE_DIALOG_MAIN', 'CLEAR_DATA', 'SET_DATA'])
  },
  computed: {
    ...mapGetters(['get_dialogMain', 'get_urls', 'get_object'])
  },
  watch: {
    get_object (val) {
      if (val.message) {
        this.$swal({
          type: 'error',
          icon: 'error',
          title: 'Error!',
          text: val.message
        })
        return
      }
      this.$swal({
        type: 'success',
        icon: 'success',
        title: 'Exitoso!',
        text: 'Permiso agregado.!'
      })
      this.SET_DATA(val)
      this.CLEAR_DATA()
      this.cancel()
    }
  }
}
</script>

<style></style>
